/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
/* eslint-disable array-callback-return */
import icons from '@assets/icons'
import {
  Badge,
  Button,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Typography,
  Menu,
} from '@material-ui/core'
import React, { useState, Fragment, useEffect } from 'react'
import application from '@config/application'
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone'
import { resellerApiWithToken } from '@api/baseApi'
import * as dayjs from 'dayjs'
import 'dayjs/locale/id'
import { useHistory } from 'react-router-dom'
import Cookies from 'js-cookie'
import { useNotification } from '@hooks/useNotification'
import Tooltip from '@material-ui/core/Tooltip'

const useStyles = makeStyles((theme) => ({
  notificationTime: {
    position: 'absolute',
    bottom: 0,
    right: 16,
    fontSize: 12,
    color: 'grey',
  },
  notification: {
    width: 340,
    borderRadius: 5,
    marginTop: 60,
    marginLeft: -150,
    border: 'solid 0.5px #cccccc',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: 8,
    },
    '&::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.3)',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 10,
      backgroundColor: 'RGBA(85,111,181,0.6)',
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: 'auto',
    },
  },
  iconButton: {
    margin: '0px 8px 0px 8px',
    '&.MuiIconButton-root': {
      backgroundColor: '#ECF2F5',
    },
  },
  listItem: {
    position: 'relative',
  },
  secondaryText: {
    '&.MuiTypography-root': {
      '&.MuiListItemText-secondary': {
        color: 'red',
      },
    },
  },
}))

const NotificationMenu = () => {
  const classes = useStyles()
  const { getNotifications, notification } = useNotification()
  const [anchorEl2, setAnchorEl2] = useState(null)
  const [menuOpen, setMenuOpen] = useState(false)
  const [countNotif, setCountNotif] = useState(0)
  const history = useHistory()
  const scope = Cookies.get('scope')
  const [notifications, setNotifications] = useState([])

  const getNotificationList = async () => {
    const api = scope === 'reseller'
      ? '/resellers/notifications'
      : '/affiliates/notifications'

    try {
      const {
        status,
        data: { badge_counts, data, unread },
      } = await resellerApiWithToken.get(api)

      if (status === 200) {
        setNotifications(data)
        setCountNotif(unread)
        const badge_count = badge_counts ?? {
          purchase_order: 12,
          sales_order: 10,
          order_management: 10,
          pre_order: 10,
          customer_reward: 1,
        }
        getNotifications({ ...notification, badge_count })
      } else {
        setNotifications([])
      }
    } catch (error) {
      setNotifications([])
    }
  }

  useEffect(() => {
    getNotificationList()
  }, [])

  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget)
  }

  const handleClose2 = () => {
    setMenuOpen(!menuOpen)
    setAnchorEl2(null)
  }

  const action = (url, id) => {
    if (url) window.location.href = url
    setMenuOpen(!menuOpen)
    setAnchorEl2(null)
    if (scope === 'reseller') {
      resellerApiWithToken.put(`/resellers/notifications/${id}`)
    } else {
      resellerApiWithToken.put(`/affiliates/notifications/${id}`)
    }
  }

  const renderNotificationMenu = () => (
    <Menu
      id="simple-menu"
      anchorEl={anchorEl2}
      keepMounted
      open={Boolean(anchorEl2)}
      onClose={handleClose2}
      elevation={0}
      classes={{
        paper: classes.notification,
      }}
    >
      <List>
        {notifications.map((item) => (
          <div key={item.id}>
            <Tooltip title={item?.message} placement="left">
              <ListItem
                button
                onClick={() => action(
                  item?.action ? `/reseller${item?.action}${item?.event?.source_id ? `&source_id=${item?.event?.source_id}` : ''}` : `/reseller/app${item?.event_type === 'PurchaseOrder'
                    ? `/purchase-order-items/details?id=${item?.event_id}`
                    : item?.event_type === 'SalesOrder'
                      ? `/sales-order-items/details?id=${item?.event_id}`
                      : item?.event_type === 'Order'
                        ? `/order-management/details?id=${item?.event_id}`
                        : item?.event_type === 'ResellerAffiliateWithdraw'
                          ? '/balance-log'
                          : item?.event_type === 'Customer'
                            ? '/'
                            : item?.event_type === 'PreOrderTransaction'
                          && `/pre-order/details?id=${item?.event_id}`
                  }${item?.event?.source_id ? `&source_id=${item?.event?.source_id}` : ''}`,
                  item.id,
                )}
                className={classes.listItem}
              >
                <ListItemIcon>
                  <img
                    src={icons.CircleGroup}
                    alt="circle group"
                    height={48}
                    width={48}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={
                  item.has_read ? item.title : <strong>{item.title}</strong>
                }
                  secondary={(
                    <Typography noWrap variant="subtitle2" gutterBottom>
                      {item.has_read ? (
                        item.message
                      ) : (
                        <strong>{item.message}</strong>
                      )}
                    </Typography>
                )}
                  variant="caption"
                  className={classes.secondaryText}
                />
                <Typography className={classes.notificationTime}>
                  {dayjs(item.created_at)
                    .locale('id')
                    .format('DD MMMM YYYY, HH:mm')}
                </Typography>
              </ListItem>
            </Tooltip>
            <Divider />
          </div>
        ))}
        <Button
          fullWidth
          onClick={() => history.push(`${application.basePath}/notifications`)}
        >
          Lihat Semua
        </Button>
      </List>
    </Menu>
  )

  return (
    <Fragment>
      <IconButton
        className={classes.iconButton}
        color="primary"
        onClick={handleClick2}
      >
        <Badge variant="standard" color="primary" badgeContent={countNotif}>
          <NotificationsNoneIcon />
        </Badge>
      </IconButton>
      {renderNotificationMenu()}
    </Fragment>
  )
}

export default NotificationMenu
